import { render } from "./DokumentZurUnterschrift.vue?vue&type=template&id=33bec866"
import script from "./DokumentZurUnterschrift.vue?vue&type=script&lang=js"
export * from "./DokumentZurUnterschrift.vue?vue&type=script&lang=js"

import "./DokumentZurUnterschrift.vue?vue&type=style&index=0&id=33bec866&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__